import { InfoGlyph } from '@upright/ui/common/generic/components/tooltip';
import { CSSProperties } from 'react';
import styled from 'styled-components';
import { BouColor } from '../../global/bou-colors';

interface Props {
  style?: CSSProperties;
}

const Root = styled.div`
  display: flex;
  align-items: center;
  color: ${BouColor.TOOL_TEXT_LIGHT_GRAY};
  transition: 0.12s ease-in-out;
  &:hover {
    color: ${BouColor.BLACK};
  }
`;

export function InfoIcon(props: Props) {
  return (
    <Root style={props.style}>
      <InfoGlyph width="1em" />
    </Root>
  );
}
